import Connexion from "../Pages/Auth/Connexion/Connexion";
import Inscription from "../Pages/Auth/Inscription/Inscription";
import PasswordOublier from '../Pages/Auth/PasswordOublier/PasswordOublier'
import ResetPassword from '../Pages/Auth/ResetPassword/ResetPassword'


import LayoutAdmin from "../Layout/LayoutAdmin/LayoutNavSide";
import User from '../Pages/Admin/User/User';
import Dashbord from "../Pages/Admin/Dashbord/Dashbord";
import Cours from "../Pages/Admin/Cours/Cours";
import CategoryCourses from '../Pages/Admin/Cours/CategoryCourses/CategoryCourses'
import AjoutCours from '../Pages/Commun/AjoutCours/AjoutCours'
import EtudiantDasbord from '../Pages/Students/EtudiantDasbord/EtudiantDasbord'


import LayoutProf from '../Layout/LayoutProf/LayoutNavSide'
import LayoutStudents from '../Layout/LayoutStudents/LayoutNavSide'


import AllCourses from '../Pages/Admin/Cours/AllCourses/AllCourses'
 import Profile from '../Pages/Admin/Profile/Profile';
 import Profil from '../Pages/Admin/Profil/Profil';
 import Parametre from '../Pages/Admin/Parametre/Parametre';




import {
  INSCRIPTION_NAVIGATION,
  CONNEXION_NAVIGATION,
  PASSWORD_OUBLIER_NAVIGATION,
  PASSWORD_RESET_NAVIGATION,


  DASHBOARD_ADMIN_NAVIGATION,
  COURS_ADMIN_NAVIGATION,
  CATEGORIE_COURS_ADMIN_NAVIGATION,
  AJOUT_COURS__ADMIN,
  ETUDIANT_DASBORD,
  USERS_ADMIN_NAVIGATION,
  PROFIL_ADMIN_NAVIGATION,
  MODIFIER_PROFIL_ADMIN_NAVIGATION,
  PARAMETRE_ADMIN_NAVIGATION,
  
  DASHBOARD_PROF_NAVIGATION,
  COURS_PROF_NAVIGATION,
  ETUDIANTS_PROF_NAVIGATION,
  PROFIL_PROF_NAVIGATION,
  MODIFIER_PROFIL_PROF_NAVIGATION,
  PARAMETRE_PROF_NAVIGATION,
  CATEGORIE_COURS_NAVIGATION,
  ALL_COURS_NAVIGATION,
  
  DASHBOARD_ETUDIANT_NAVIGATION,
  COURS_ETUDIANT_NAVIGATION,
  PROFIL_ETUDIANT_NAVIGATION,
  MODIFIER_PROFIL_ETUDIANT_NAVIGATION,
  PARAMETRE_ETUDIANT_NAVIGATION,
  USERS_ADMIN_NAVIGATION_ETUDIANTS,
} from "./NAVIGATION_PATH";
import ProfPage from "../Pages/Admin/User/ProfPage/ProfPage";
import StudentPage from "../Pages/Admin/User/StudentPage/StudentPage";

export const authRoutes = [
  {
    path: CONNEXION_NAVIGATION,
    element: <Connexion />,
  },
  {
    path: INSCRIPTION_NAVIGATION,
    element: <Inscription />,
  },
  {
    path: PASSWORD_OUBLIER_NAVIGATION,
    element: <PasswordOublier />,
  },
  {
    path: PASSWORD_RESET_NAVIGATION,
    element: <ResetPassword />,
  },
];
export const adminRoutes = [
    {
      path: DASHBOARD_ADMIN_NAVIGATION,
      element: <LayoutAdmin />,
      children: [
        {
          path: '?',
          element: <Dashbord/>
        },
        {
          path: COURS_ADMIN_NAVIGATION,
          element: <Cours />,
          children : [
            {
              path : '?',
              element: <AllCourses />
            },
            {
              path: CATEGORIE_COURS_NAVIGATION,
              element: <CategoryCourses/>
            },
          ]
        },

        {
          path: AJOUT_COURS__ADMIN,
          element: <AjoutCours/>
        },
        {
          path: ETUDIANT_DASBORD,
          element: <EtudiantDasbord/>
        },
        {
          path: USERS_ADMIN_NAVIGATION,
          element: <User/>,
          children:[
            {
              path: '?',
              element: <ProfPage/>
            },
            {
              path: USERS_ADMIN_NAVIGATION_ETUDIANTS,
              element: <StudentPage/>
            },
          ]
        },
       
        {
          path: PROFIL_ADMIN_NAVIGATION,
          element: <Profil/>

        },
        {
          path: MODIFIER_PROFIL_ADMIN_NAVIGATION,
          element: <Profile/>

        },
        {
          path: PARAMETRE_ADMIN_NAVIGATION,
          element: <Parametre/>
        },
      ]
    },
  ];
  export const profRoutes = [
    {
      path: DASHBOARD_PROF_NAVIGATION,
      element: <LayoutProf />,
      children: [
        {
          path: '?',
          element: <EtudiantDasbord/>
        },
        {
          path: COURS_PROF_NAVIGATION,
          element: <h1>Hello - cours</h1>
        },
        {
          path: ETUDIANTS_PROF_NAVIGATION,
          element: <h1>Hello - etudiants</h1>
        },
        {
          path: PROFIL_PROF_NAVIGATION,
          element: <Profil/>

        },
        {
          path: MODIFIER_PROFIL_PROF_NAVIGATION,
          element: <Profile/>
        },
        {
          path: PARAMETRE_PROF_NAVIGATION,
          element: <Parametre/>
        },
      ]
    },
  ];
  export const etudiantRoutes = [
    {
      path: DASHBOARD_ETUDIANT_NAVIGATION,
      element: <LayoutStudents />,
      children: [
        {
          path: '?',
          element: <EtudiantDasbord/>
        },
        {
          path: PROFIL_ETUDIANT_NAVIGATION,
          element: <Profil/>
        },
        {
          path: MODIFIER_PROFIL_ETUDIANT_NAVIGATION,
          element: <Profile/>
        },
        {
          path: PARAMETRE_ETUDIANT_NAVIGATION,
          element: <Parametre/>
        },
      ]
    },
  ];



  
